import React from "react";
import ProjectCard from "../../components/ProjectCard";
import { projectData } from "../../data";

export default function Projects() {
  return (
    <div className="bg-neutral-200 dark:bg-neutral-900 relative">
      <div className="py-20">
        <div className="container px-4 mx-auto">
          <div className="text-center">
            <h2 className="headline text-neutral-900 dark:text-neutral-100 my-14">
              All Projects
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
            {projectData.map((item) => (
              <ProjectCard project={item} key={item.id} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
